import {ADD_ACCESS_TOKEN, DEFAULT_USER_STATE, LOG_OUT} from "../constants";

function UserReducer(state = DEFAULT_USER_STATE, action) {

    let type = action.type

    switch (type) {

        case LOG_OUT:
            return {
                ...state,
                accessToken: ""
            }

        case ADD_ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.payload
            }

        default:
            return state
    }
}

export default UserReducer